var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88722 14.4361V11.5489H2.74286C2.22957 11.5489 1.78847 11.3805 1.41955 11.0436C1.05063 10.7068 0.850125 10.2897 0.818045 9.79248L0 0H2.35789C3.0797 0 3.70526 0.224561 4.23459 0.673684C4.76391 1.12281 5.09273 1.70025 5.22105 2.40601L5.77444 5.77444H9.62406C10.6827 5.77444 11.589 6.15138 12.3429 6.90526C13.0967 7.65915 13.4737 8.56541 13.4737 9.62406V11.5489H11.5489V14.4361H9.62406V11.5489H4.81203V14.4361H2.88722ZM11.5489 9.62406C11.5489 9.09474 11.3606 8.64176 10.9839 8.26514C10.6073 7.88852 10.154 7.69989 9.62406 7.69925H4.13835L3.3203 2.74286C3.28822 2.50226 3.18011 2.30592 2.99597 2.15386C2.81183 2.0018 2.59914 1.92545 2.35789 1.92481H2.09323L2.74286 9.62406H11.5489Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatIcon);
export default __webpack_public_path__ + "static/media/seat-icon.b0fac27c970a53e200ff18321776e283.svg";
export { ForwardRef as ReactComponent };